import Vue from 'vue';
import Router from 'vue-router';
// import routes from './routes';
import iView from 'iview';

Vue.use(iView);
Vue.use(Router);

var routes = [{
  path: '',
  name: 'home',
  meta: { title: '管理系统' },
  component: () => import('@/views/home/index.vue')
}, {
  path: '/qrcode/signature',
  name: 'signature',
  meta: { title: '添加签名' },
  component: () => import('@/views/qrcode/signature/index.vue')
}, {
  path: '/qrcode/openApprove',
  name: 'openApprove',
  meta: { title: '扫描成功' },
  component: () => import('@/views/qrcode/openApprove/index.vue')
}, {
  path: '/qrcode/rebarReceive',
  name: 'rebarReceive',
  meta: { title: '钢筋实收' },
  component: () => import('@/views/qrcode/rebarReceive/index.vue')
}];

const router = new Router({
  routes: routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/router.js